import * as React from 'react'
import { Check } from 'lucide-react'
import { cn } from '../utils'

export interface CheckboxProps {
  children?: React.ReactNode
  isSelected?: boolean
  onChange?: (isSelected: boolean) => void
  className?: string
  disabled?: boolean
  id?: string
  name?: string
}

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ children, isSelected, onChange, className, disabled, id, name }, ref) => {
    const inputId = id ?? React.useId()
    
    return (
      <label
        htmlFor={inputId}
        className={cn(
          'flex items-center gap-3 cursor-pointer',
          disabled && 'opacity-50 cursor-not-allowed',
          className
        )}
      >
        <div className="relative">
          <input
            ref={ref}
            id={inputId}
            name={name}
            type="checkbox"
            checked={isSelected}
            onChange={(e) => onChange?.(e.target.checked)}
            disabled={disabled}
            className="sr-only peer"
          />
          <div
            className={cn(
              'w-5 h-5 rounded',
              'border-2 border-gray-300',
              'flex items-center justify-center',
              'peer-hover:border-gray-400',
              'peer-focus-visible:ring-2 peer-focus-visible:ring-primary-500 peer-focus-visible:ring-offset-2',
              'peer-checked:bg-primary-600 peer-checked:border-primary-600',
              'transition-all duration-150 ease-out'
            )}
          >
            {isSelected && (
              <Check className="w-3 h-3 text-white" strokeWidth={3} />
            )}
          </div>
        </div>
        {children && (
          <span className="text-sm text-gray-700">{children}</span>
        )}
      </label>
    )
  }
)
Checkbox.displayName = 'Checkbox'
